import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { Nunito, Gutter } from '../../GlobalStyles';

import IconRound from '../IconRound/IconRound';

const TitleContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: ${props => (props.noMargin ? '0px' : Gutter)};
  .title-icon {
    margin-top: 20px;
  }
`;

const TitleText = styled('h2')`
  font-family: ${Nunito};
  color: ${props => props.theme.textColor};
  margin-top: 35px;
  text-align: center;
`;

const Title = ({
  children,
  icon,
  noMargin,
}) => (
  <TitleContainer
    className={icon === 'note' ? 'note-title-container' : 'title-container'}
    noMargin={noMargin}
  >
    <IconRound
      className='title-icon'
      icon={icon}
      xLarge
    />
    <TitleText>
      {children}
    </TitleText>
  </TitleContainer>
);

Title.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string.isRequired,
  noMargin: PropTypes.bool,
};

Title.defaultProps = {
  noMargin: false,
};

export default Title;
